<script setup lang="ts">
import usePoolStore from '~~/app/store/pool'
import type { PoolSchedule } from '~~/interfaces/poolDetail'

const { t } = useI18n()

const Days = [
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY'
]

const days = ref(Days)

const accessTypeLabel = computed<string>(
    () => usePoolStore().poolAccess?.accessType?.label || ''
)

const openingHours = (index: number): string => {
    const day = (usePoolStore().poolAccess?.schedules as PoolSchedule[])?.find(
        (d: PoolSchedule) => d.day === index + 1
    )

    if (!day) {
        return t('closed')
    }

    const openingTime = day?.openingTime.split(':')
    const closingTime = day?.closingTime.split(':')

    return `${openingTime[0]}:${openingTime[1]} - ${closingTime[0]}:${closingTime[1]}`
}

onMounted(() => {
    usePoolStore().fetchPoolAccess()
})
</script>

<template>
    <div>
        <Loader v-if="usePoolStore().communityPoolAccessLoader" />
        <div v-else class="text-sm">
            <div v-if="accessTypeLabel" class="flex mb-1">
                <p class="w-1/2 text-[#777777]">
                    {{ accessTypeLabel }}
                </p>
                <p class="w-1/2 text-gray-l-700">{{ $t('yes') }}</p>
            </div>

            <div
                v-if="usePoolStore().poolAccess?.isParkingFree !== null"
                class="flex mb-1"
            >
                <p class="w-1/2 text-[#777777]">{{ $t('parking') }}</p>
                <p class="w-1/2 text-gray-l-700">
                    {{
                        usePoolStore().poolAccess?.isParkingFree
                            ? $t('free_parking')
                            : $t('paid_parking')
                    }}
                </p>
            </div>

            <div
                v-if="usePoolStore().poolAccess?.isAlwaysOpen"
                class="flex mb-1"
            >
                <p class="w-1/2 text-[#777777]">{{ $t('open_24_24') }}</p>
                <p class="w-1/2 text-gray-l-700">{{ $t('yes') }}</p>
            </div>
            <div v-else>
                <h3
                    class="flex justify-center w-full text-lg mt-3 text-gray-l-800 font-bold mb-0.5"
                >
                    {{ $t('opening_hours') }}
                </h3>
                <div
                    v-for="(day, index) in days"
                    :key="index"
                    class="flex mb-0.5"
                >
                    <p class="w-1/2 text-[#777777]">
                        {{ $t(`days.${day.toLowerCase()}`) }}
                    </p>
                    <p class="text-gray-l-700">
                        {{ openingHours(index) }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
